import React, { useRef, useState } from "react";
import Slider from "react-slick";
import LazyImage from "../../shared/lazyImage";

const ProductCarousel = ({ activeVariant, productDetails, productImage }) => {
  const mainSliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  const images = [productImage];

  const mainSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
    dotsClass: "slick-dots custom-dots",
  };

  const goToPrev = () => mainSliderRef.current?.slickPrev();
  const goToNext = () => mainSliderRef.current?.slickNext();

  return (
    <div>
      <div className="product-details__left">
        <div
          className="product-details__thumb-slider overflow-hidden position-relative"
          style={{ padding: 0 }}
        >
          <Slider ref={mainSliderRef} {...mainSettings}>
            {images.map((img, index) => (
              <div key={index}>
                <div
                  className="product-carousel-image"
                  style={{
                    width: "100%",
                    height: "500px",
                    // display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <LazyImage
                    src={
                      productDetails?.product_image ||
                      activeVariant?.product_image
                    }
                    alt={productDetails?.product_name}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </div>
            ))}
          </Slider>

          {images.length > 1 && (
            <>
              <button
                onClick={goToPrev}
                className="position-absolute top-50 start-0 translate-middle-y ms-12 z-2"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  background: "rgba(255,255,255,0.9)",
                  border: "1px solid #e5e7eb",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  transition: "all 0.2s",
                }}
              >
                <i className="ph ph-caret-left text-gray-700" />
              </button>
              <button
                onClick={goToNext}
                className="position-absolute top-50 end-0 translate-middle-y me-12 z-2"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  background: "rgba(255,255,255,0.9)",
                  border: "1px solid #e5e7eb",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  transition: "all 0.2s",
                }}
              >
                <i className="ph ph-caret-right text-gray-700" />
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCarousel;
